/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Person } from '../person.model';
import { PersonService } from '../person.service';
import { UntypedFormGroup } from '@angular/forms';
import { ToastMessageOptions } from 'primeng/api';

//TODO rename to iriro-person-shared
@Component({
  selector: 'pwl-person-shared, iriro-person-shared ',
  templateUrl: './person-shared.component.html',
  styleUrls: ['./person-shared.component.scss'],
})
export class PersonSharedComponent implements OnInit {
  @Input() new!: boolean;
  @Input() form!: UntypedFormGroup;

  @Output() personFound = new EventEmitter<boolean>();

  found = false;
  people!: Array<Person>;
  msgs: Array<ToastMessageOptions> = [];

  constructor(private readonly personService: PersonService) {}

  ngOnInit() {
    if (this.new) this.form.reset();
  }

  showWarn() {
    this.msgs = [];
    this.msgs.push({ severity: 'warn', summary: 'Atentie!', detail: 'Persoana exista deja, nu se mai poate adauga' });
  }

  reset() {
    this.found = false;
    this.personFound.emit(this.found);
    this.form.reset();
  }

  filterPerson(query: string, field: string) {
    const lazyEvent = {
      filters: {} as Record<string, any>,
    };
    lazyEvent.filters[field ] = {
      value: query,
      matchMode: 'contains',
    };
    this.personService.getPeople(lazyEvent).subscribe((data: any) => {
      this.people = data.page.totalElements > 0 ? data._embedded.entityModels : [];
    });
  }

  onAutoCompleteSelect(person: Person) {
    this.form.patchValue(person);
    this.found = true;
    this.personFound.emit(this.found);
    this.showWarn();
  }

  getPersonDisplayLabel = (person: Person | null): string => {
    return person?.name ?? '';
  };

  comparePersonByName = (a: Person | null, b: Person | null): boolean => {
    return a?.name === b?.name;
  };
}
